import { render } from "./ShowPostales.vue?vue&type=template&id=a8f66bc8&scoped=true"
import script from "./ShowPostales.vue?vue&type=script&lang=js"
export * from "./ShowPostales.vue?vue&type=script&lang=js"

import "./ShowPostales.vue?vue&type=style&index=0&id=a8f66bc8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a8f66bc8"

export default script